import { Waiter } from 'types/state';
import { sportingAPI } from '../api';

export const getWaiters = async (): Promise<Waiter[]> => {
  const waiters = await sportingAPI.booking.getWaiters();

  return waiters;
};
